var map = {
	"./adult/de/wordchain-data.json": 784,
	"./adult/nn/wordchain-data.json": 785,
	"./adult/no/wordchain-data.json": 786,
	"./youth/de/wordchain-data.json": 787,
	"./youth/nn/wordchain-data.json": 788,
	"./youth/no/wordchain-data.json": 789,
	"./youth/se/wordchain-data.json": 790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 783;